<template>
  <div class="my-swiper-wrapper relative width-full hidden" ref="wrapper">
    <div
      class="my-swiper-container"
      ref="swiper"
      :class="{ animative: allowDuration }"
      :style="{
        transform: `translate3d(-${translateX}px, 0px, 0px)`,
        transitionDuration: `${allowDuration ? speed : 0}ms`
      }"
      @transitionstart="onTransitionStart"
      @transitionend="onTransitionEnd"
    >
      <slot name="content"></slot>
    </div>
    <div class="swiper-dots absolute fb fb-cross-center fb-main-center">
      <span
        class="dots-item"
        :class="{ active: currentTabIndex === item }"
        v-for="(item, index) in slotsNum"
        :key="`banner${index}`"
      ></span>
    </div>
  </div>
</template>

<script>
import { EScroll } from '@/utils/comUtils'
export default {
  components: {},
  props: {
    loop: {
      type: Boolean,
      default: false
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    speed: {
      type: Number,
      default: 500
    },
    initialSlide: {
      type: Number,
      default: 0
    },
    offset: {
      type: Number,
      default: 50
    },
    delay: {
      type: Number,
      default: 3000
    },
    slotsNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      translateX: 0, // 真实偏移值
      allowDuration: false, // 是否运行过度效果
      originTx: 0, // 元偏移值 方便计算
      currentTabIndex: this.initialSlide || 0, // 初始化下标
      swiper: null, // swiper实例
      swippable: true, // 是否可滑动切换
      realChildren: 0, // 真实节点数量
      timer: null, // 自动播放定时器
      direction: 'right', // 滚动方向
      transitoning: false, // 是否正在执行动画 防止此时拖动
      replacingIndex: false, // 是否正在替换下标 loop的是否不需要过度
      touchMoving: false // 防止点击事件没有触发move的同时触发到了touchstart和touchend
    }
  },
  computed: {},
  watch: {
    currentTabIndex(realIndex) {
      this.originTx = 0
      this.updateTranslateX()
      this.transitoning = true
      // 没有在 替换节点 就开启动画
      !this.replacingIndex && (this.allowDuration = true)
      if (this.loop) {
        if (realIndex === this.realChildren + 1 || !realIndex) {
          return
        }
        this.$emit('slideChange', {
          realIndex: this.loop ? realIndex - 1 : realIndex
        })
      } else {
        this.$emit('slideChange', {
          realIndex
        })
      }
      // alert(`readIndex--> ${realIndex}`)
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.translateX = this.$refs.wrapper.clientWidth * this.currentTabIndex
    this.originTx = this.translateX // 保留原始偏移值
    this.swippable =
      this.$refs.swiper.parentNode.className.indexOf('swiper-no-swiping') < 0
    // 根据子节点设置容器宽度
    this.$nextTick(() => {
      this.realChildren = this.$refs.swiper.childNodes.length
      this.$refs.swiper.style.width = `${this.realChildren * 100}%`
      if (this.loop && this.realChildren > 1) {
        this.updateContent()
      }
      if (this.swippable && this.realChildren > 1) {
        this.initSwiper()
      }
    })
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    this.swiper && this.swiper.destroy()
    this.timer && clearInterval(this.timer)
  },
  destroyed() {},
  methods: {
    initSwiper() {
      let _that = this
      this.swiper = EScroll({
        dom: this.$refs.swiper,
        minMove: 50,
        stop: false,
        start() {
          if (_that.transitoning) return false
          _that.autoPlay && clearInterval(_that.timer) // 设置了自动轮播就清除
          _that.allowDuration = false
        },
        move(params) {
          if (_that.transitoning) return false
          _that.touchMoving = true
          if (params.direction < 3) {
            return false
          }
          let _x = 0
          if (!_that.currentTabIndex) {
            if (params.dx > 0) {
              _x = 0
            } else {
              _x = -params.dx
            }
          } else {
            if (
              _that.currentTabIndex ===
              (_that.loop ? _that.realChildren + 1 : _that.realChildren - 1)
            ) {
              if (params.dx > 0) {
                _x = -params.dx
              } else {
                _x = 0
              }
            } else {
              _x = -params.dx
            }
          }
          _that.translateX = _that.originTx + _x
        },
        end(params) {
          if (!_that.touchMoving) return false
          if (_that.transitoning) return false
          if (params.direction < 3) return false
          /* eslint-disable */
          let _tab = 0
          if (!_that.currentTabIndex) {
            // 如果是第一个tab 3：向左，4：向右 如果往左滑动距离大于偏移值 就切换tab
            _tab =
              params.direction === 3
                ? 0
                : Math.abs(params.dx) > _that.offset
                ? _that.currentTabIndex + 1
                : 0
          } else {
            if (
              _that.currentTabIndex ===
              (_that.loop ? _that.realChildren + 1 : _that.realChildren - 1)
            ) {
              // 如果是最后一个tab 3：向左，4：向右 如果往右边滑动距离大于偏移值 就切换tab
              _tab =
                params.direction === 3
                  ? Math.abs(params.dx) > _that.offset
                    ? _that.currentTabIndex - 1
                    : _that.currentTabIndex
                  : _that.currentTabIndex
            } else {
              // 如果是中间的tab 3：向左，4：向右 如果往右边滑动距离大于偏移值 就切换tab
              _tab =
                Math.abs(params.dx) > _that.offset
                  ? _that.currentTabIndex + params.dx > 0
                    ? _that.currentTabIndex - 1
                    : _that.currentTabIndex + 1
                  : _that.currentTabIndex
            }
          }
          if (_tab === _that.currentTabIndex) {
            _that.updateTranslateX()
            _that.originTx = 0
            return false
          }
          _that.currentTabIndex = _tab
          _that.direction = params.direction === 3 ? 'left' : 'right'
          _that.autoPlay && _that.runTimer() // 设置了自动轮播就重新开启
          /* eslint-enable */
          _that.touchMoving = false
        }
      })

      if (this.autoPlay && this.realChildren > 1) {
        this.runTimer()
      }
    },
    slideTo(index) {
      this.currentTabIndex = index
    },
    destroy() {
      this.swiper.removeEvents()
    },
    onTransitionStart() {
      this.$emit('onTransitionStart', {
        realIndex: this.currentTabIndex,
        direction: this.direction
      })
    },
    onTransitionEnd() {
      // 设置可以拖拽
      this.transitoning = false
      // 循环的时候才进行如下判断
      if (this.loop) {
        this.replacingIndex =
          this.currentTabIndex === 0 ||
          this.currentTabIndex === this.realChildren + 1
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.currentTabIndex === 0) {
              this.currentTabIndex = this.realChildren
            } else if (this.currentTabIndex === this.realChildren + 1) {
              this.currentTabIndex = 1
            }
          }, 50)
          if (
            this.currentTabIndex === 0 ||
            this.currentTabIndex === this.realChildren + 1
          ) {
            setTimeout(() => {
              this.replacingIndex = false
              this.transitoning = false
            }, 100)
          }
        })
      }
      if (!this.allowDuration) {
        return false
      }
      this.allowDuration = false
      this.$emit('onTransitionEnd', {
        realIndex: this.currentTabIndex,
        direction: this.direction
      })
    },
    updateTranslateX() {
      this.translateX = this.$refs.wrapper.clientWidth * this.currentTabIndex
      this.originTx = this.translateX // 保留原始偏移值
    },
    runTimer() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.loop) {
          // 循环播放
          if (this.direction === 'right') {
            this.currentTabIndex === this.realChildren + 1
              ? (this.currentTabIndex = 0)
              : ++this.currentTabIndex
          } else if (this.direction === 'left') {
            this.currentTabIndex === this.realChildren + 1
              ? (this.currentTabIndex = this.realChildren + 1)
              : --this.currentTabIndex
          }
        }
        this.slideTo(this.currentTabIndex)
      }, this.delay)
    },
    updateContent(forceUpdate = false) {
      let swiper = this.$refs.swiper
      // 解决loop模式下更新数据
      if (forceUpdate) {
        let _lastChild = swiper.childNodes[1].cloneNode(true)
        let _firstChild = swiper.childNodes[this.realChildren].cloneNode(true)
        swiper.replaceChild(_firstChild, swiper.firstChild)
        swiper.replaceChild(_lastChild, swiper.lastChild)
      } else {
        this.replacingIndex = true
        // 把头尾各拷贝一份出来
        let _lastChild = swiper.firstChild.cloneNode(true)
        let _firstChild = swiper.lastChild.cloneNode(true)
        swiper.insertBefore(_firstChild, swiper.firstChild)
        swiper.appendChild(_lastChild)
        this.currentTabIndex = this.initialSlide + 1
        swiper.style.width = `${(this.realChildren + 2) * 100}%`
        this.$nextTick(() => {
          this.replacingIndex = false
          this.transitoning = false
          this.slideTo(this.currentTabIndex)
        })
      }
    },
    getChildHeight() {
      let node = this.$refs.swiper.childNodes[this.currentTabIndex]
        .childNodes[0]
      return (
        node.offsetHight ||
        node.getBoundingClientRect().height ||
        node.scrollHeight
      )
    },
    slideToPrev() {
      --this.currentTabIndex
      this.slideTo(this.currentTabIndex)
    },
    slideToNext() {
      ++this.currentTabIndex
      this.slideTo(this.currentTabIndex)
    }
  }
}
</script>

<style lang="scss" scoped>
.my-swiper-wrapper {
  .my-swiper-container {
    display: flex;
    overflow: hidden;
    backface-visibility: hidden;
    position: relative;
    transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
    &.animative {
      transition: all ease 0.5s;
    }
    > div {
      flex: 1;
    }
  }
  .swiper-dots {
    height: 32px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    .dots-item {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 3px;
      opacity: 0.4;
      background: #fff;
      margin: 0 3px;
      &.active {
        opacity: 1;
      }
    }
  }
}
</style>
